import React , { Component } from 'react';
import Aux from '../Aux/Aux';
import './Layout.css';
import classes from './Layout.css';
import SideDrawer from '../../Components/Navigation/SideDrawer/Sidedrawer';

import Toolbar from '../../Components/Navigation/ToolBar/ToolBar'

class Layout extends Component {

    state = {
        sideDrawerShow: false,
    };

    sideDrawerClosedHandler = () => {
        this.setState({
            sideDrawerShow: false,
        })
    };

    sideDrawerToggleHandler = () => {
        this.setState((prevState) => {
            return {sideDrawerShow: !prevState.sideDrawerShow }
        })
    };

    render () {
        return (
            <Aux>
                <Toolbar drawerToggleClicked={this.sideDrawerToggleHandler}/>
                <SideDrawer
                    open={this.state.sideDrawerShow}
                    closed={this.sideDrawerClosedHandler}
                />
                <div className={classes.Content}>
                   {this.props.children}
                </div>
            </Aux>

        )
    }
}

export default Layout;


// WEBPACK FOOTER //
// ./src/Hoc/Layout/Layout.js